import { TrackingEventNames as BaseTrackingEventNames } from '../../common/tracking/tracking-event-names.model';

export const TrackingEventNames = {
  ...BaseTrackingEventNames
};
